import { useTranslation } from 'react-i18next';

import { LoadingSpinner } from 'components/loader/LoadingSpinner.styles';
import Tooltip from 'components/tooltip/Tooltip';
import { TriggerLogType } from 'models/automation/Triggers';
import {
  CheckFillCircleIconStyled,
  XCircleFillIconStyled,
} from './TriggerLogTypeIcon.styles';

interface TriggerLogTypeIconProps {
  type: TriggerLogType;
}

const TriggerLogTypeIcon = ({ type }: TriggerLogTypeIconProps) => {
  const { t } = useTranslation();
  const text = t('pageAutomations.triggers.triggerLogType', { context: type });
  const tooltipText = t('pageAutomations.triggers.triggerLogTypeTooltip', {
    context: type,
  });

  if (type === TriggerLogType.FAILURE) {
    return (
      <Tooltip id={`${type}-tooltip`} text={tooltipText}>
        <XCircleFillIconStyled aria-label={text} />
      </Tooltip>
    );
  }

  if (type === TriggerLogType.SUCCESS_NOT_SENT) {
    return (
      <Tooltip id={`${type}-tooltip`} text={tooltipText}>
        <LoadingSpinner aria-label={text} />
      </Tooltip>
    );
  }

  if (type === TriggerLogType.SUCCESS_SENT) {
    return (
      <Tooltip id={`${type}-tooltip`} text={tooltipText}>
        <CheckFillCircleIconStyled aria-label={text} />
      </Tooltip>
    );
  }

  return text;
};

export default TriggerLogTypeIcon;
